/**
 * シングルクオートで囲まれた文字列をエスケープする。
 *
 * @param str エスケープ対象の文字列
 * @returns エスケープ後の文字列
 */
export const escapeSingleQuotedString = (str: string) => {
  return str.replace(/['\\\r\n<]/g, (ch: string) => {
    switch (ch) {
      case '\\':
        return '\\\\';
      case "'":
        return "\\'";
      case '\r':
        return '\\r';
      case '\n':
        return '\\n';
      case '<':
        return '\\u003c'; // </script>対策
      default:
        return ch;
    }
  });
};

/**
 * HTML埋め込み用にJSON文字列をエスケープする。RailsのActiveSupport::JSON.encodeと同じエスケープ処理を行う。
 * https://github.com/rails/rails/blob/a801911a03a33af79aec0063ae76805bdabd938d/activesupport/lib/active_support/json/encoding.rb#L43
 *
 * @param str エスケープ対象の文字列
 * @returns エスケープ後の文字列
 */
export const escapeJson = (str: string): string => {
  // JSC(Safari, Bun)だとreplaceAllを連ねたほうがパフォーマンスが良い
  // A: 関数での置換, B: replaceAllでの置換, C: 正規表現（/.../g）での置換
  // [V8 (Chrome 130.0.6723.69)] A: 41,600ops/s, B: 36,469ops/s, C: 36,400ops/s
  // [SpiderMonkey (FF 131.0.3)] A: 47.008ops/s, B: 12,670ops/s, C: 15,496ops/s
  // [JSC (Safari v17.5)] A: 21,216ops/s, B: 28,080ops/s, C: 10,231ops/s
  return str.replace(/[<>&\u2028\u2029]/g, (ch: string) => {
    switch (ch) {
      // </script>を避けるためのエスケープ
      case '<':
        return '\\u003c';
      case '>':
        return '\\u003e';
      // HTML Character Entityのエスケープ
      case '&':
        return '\\u0026';
      // IEやiOS9でinitial stateがparseできないことがある問題の対処
      // https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#Issue_with_plain_JSON.stringify_for_use_as_JavaScript
      case '\u2028':
        return '\\u2028';
      case '\u2029':
        return '\\u2029';
      default:
        return ch;
    }
  });
};
